import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaWindowClose } from 'react-icons/fa';
import { motion } from 'framer-motion';

function VariationForm({ productId, weburl, color, size, handleIsMultiImages }) {
    const [dataMultiImages, setDataMultiImages] = useState([]);
    const [selectedColorId, setSelectedColorId] = useState(''); // State for selected color
    const [selectedSizeId, setSelectedSizeId] = useState(''); // State for selected size
    const [selectedImage, setSelectedImage] = useState(null); // State for uploaded image
const[loading,setLoading]=useState(false);
    // Fetch multi images when productId changes
    useEffect(() => {
        axios.get(`api/onlinestore/get/multiimage/${productId}`)
            .then((res) => {
                setDataMultiImages(res.data); // Set the response data to state
               
            })
            .catch((error) => {
                console.error('Error fetching multi images:', error); // Handle errors
            });
    }, [productId,loading]);

    // Handle form submission
    const handleSubmit = (e) => {
        setLoading(true);
        e.preventDefault();

        // Create a FormData object
        const formData = new FormData();
        formData.append('product_id', productId); // Append product ID
        formData.append('color_id', selectedColorId); // Append selected color ID
        formData.append('size_id', selectedSizeId); // Append selected size ID
        if (selectedImage) {
            formData.append('image', selectedImage); // Append uploaded image
        }

        try {
            // First, get the CSRF cookie to set up CSRF protection
            axios.get('/sanctum/csrf-cookie')
                .then(async () => {
                    // Once the CSRF cookie is set, post the form data
                    const postResponse = await axios.post('/api/post/onlinestore/product/variations', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });

                    alert(postResponse.data.message); // Show success message
                   setLoading(false);
                   
                });
        } catch (error) {
            console.error('Error saving variations:', error); // Handle errors
        }
    };
    const handleDeleteVariation = async (id, e) => {
        e.preventDefault();
        
        try {
          // Confirm deletion with user
          if (!window.confirm('Are you sure you want to delete this variation?')) {
            return;
          }
      
          // Call the delete API endpoint
          const response = await axios.delete(`api/onlinestore/variation/delete/${id}`);
      
          if (response.data.success) {
            // Remove the deleted item from state
            setDataMultiImages(prevData => prevData.filter(item => item.id !== id));
            
            // Optional: Show success message
            alert('Variation deleted successfully!');
          } else {
            throw new Error(response.data.message || 'Failed to delete variation');
          }
        } catch (error) {
          console.error('Delete error:', error);
          alert(error.message || 'Error deleting variation');
        }
      };
    return (
        <motion.div
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: -500 }}
            exit={{ opacity: 0, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className='fixed bg-blue-300 top-[5%] z-40 mx-2 text-black p-2 w-[80%] rounded-lg shadow-lg'>
                <div className='flex justify-between'>
                    <button onClick={handleIsMultiImages} className='bg-red-600 hover:bg-red-900 flex justify-center items-center rounded-full h-10 text-sm text-center w-10 text-white p-2'>
                        <FaWindowClose className='size-6' />
                    </button>
                </div>

                <form encType="multipart/form-data" method='post' onSubmit={handleSubmit} className='mt-7 grid grid-cols-1 bg-white p-4 rounded-md shadow-md'>
                <div className="max-h-[200px] overflow-y-auto"> {/* Adjust max-height as needed */}
  <table className='w-full border-collapse border border-gray-300'>
    <thead>
      <tr className='bg-gray-100 sticky top-0'> {/* Makes header sticky */}
        <th className='p-2 border border-gray-300 text-left w-[5%]'>Sr</th>
        <th className='p-2 border border-gray-300 text-left w-[20%]'>Name</th>
        <th className='p-2 border border-gray-300 text-left w-[15%]'>Image</th>
        <th className='p-2 border border-gray-300 text-left w-[20%]'>Color</th>
        <th className='p-2 border border-gray-300 text-left w-[20%]'>Size</th>
        <th className='p-2 border border-gray-300 text-left w-[20%]'>Delete</th>
      </tr>
    </thead>
    <tbody>
      {dataMultiImages.length > 0 && dataMultiImages.map((item, index) => (
        <tr key={item.id} className='hover:bg-gray-50'>
          <td className='p-2 border border-gray-300 align-middle'>{index + 1}</td>
          <td className='p-2 border border-gray-300 align-middle'>{item.name.slice(0,20)}</td>
          <td className='p-2 border border-gray-300 align-middle'>
            <img className='h-10 w-10 mx-auto object-cover' src={`${weburl}/${item.image_url}`} alt={item.name} />
          </td>
          <td className='p-2 border border-gray-300 align-middle'>{item.colorName}</td>
          <td className='p-2 border border-gray-300 align-middle'>{item.sizeName}</td>
          <td className='p-2 border border-gray-300 align-middle'>
            <button onClick={(e)=>handleDeleteVariation(item.id,e)} className='text-red-600 hover:text-red-900'>Delete</button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

                    <div className='flex mt-2 gap-2'>
                        {/* Color Dropdown */}
                        <select
                            className='p-2 border w-full rounded-lg focus:outline-none focus:border-blue-500'
                            value={selectedColorId}
                            onChange={(e) => setSelectedColorId(e.target.value)} // Update selected color
                        >
                            <option value=''>Select Color</option>
                            {color.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>

                        {/* Size Dropdown */}
                        <select
                            className='p-2 border w-full rounded-lg focus:outline-none focus:border-blue-500'
                            value={selectedSizeId}
                            onChange={(e) => setSelectedSizeId(e.target.value)} // Update selected size
                        >
                            <option value=''>Select Size</option>
                            {size.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>

                        {/* File Input */}
                        <input
                            type='file'
                            name='image'
                            className='p-2 border w-full rounded-lg focus:outline-none focus:border-blue-500'
                            onChange={(e) => setSelectedImage(e.target.files[0])} // Update selected image
                        />

                        {/* Save Button */}
                        <button
                            type='submit'
                            className='bg-green-500 p-2 w-full rounded-lg shadow-md hover:bg-green-600 text-white focus:outline-none'
                       
                       >
                        {loading?'wait':'save'}
                       
                        </button>
                    </div>
                </form>
            </div>
        </motion.div>
    );
}

export default VariationForm;